<template>
  <div class="advanced-search-result">
    <img
      v-show="thumbnail"
      :src="thumbnail"
      :alt="alt"
      class="advanced-search-result__thumbnail"
    >
    <a
      class="advanced-search-result__title"
      :href="link"
      @click="pushGTM"
    >{{
      title
    }}</a>
    <div class="advanced-search-result__container">
      <p
        v-show="!!description"
        class="advanced-search-result__description"
      >
        {{ description }}
      </p>
      <div class="advanced-search-result__info">
        <p
          v-show="!!categories"
          class="advanced-search-result__category"
        >
          {{ categories }}
        </p>
        <p
          v-show="!!date"
          class="advanced-search-result__date"
        >
          {{ date }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import isOutbound from '@tagging/isOutbound.js'

export default {
  name: 'advanced-search-result',
  props: {
    alt: {
      type: String,
    },
    thumbnail: {
      type: String,
    },
    link: {
      type: String,
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    type: {
      type: String,
    },
    categories: {
      type: String,
    },
    date: {
      type: String,
    },
    query: {
      type: String,
    },
  },
  methods: {
    pushGTM(event) {
      const target = event.target.closest('a')
      window.dataLayer.push({
        event: 'click',
        section: 'resultados-busca',
        label: this.title,
        url_redirect: this.link,
        outbound: isOutbound(target),
        name: this.query
      })
    },
  },
}
</script>
